var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("app-header", {
    scopedSlots: _vm._u([
      {
        key: "brand",
        fn: function () {
          return [
            _c(
              "a",
              {
                staticClass: "navbar-item header-logo gtm-header-nav-logo",
                attrs: { href: "/" },
              },
              [
                _c("img", {
                  staticClass: "dc-logo",
                  attrs: {
                    src: require("@/assets/dc_header_logo.svg"),
                    alt: "DailyAccess",
                  },
                }),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "navigation",
        fn: function () {
          return [_c("navigation", { staticClass: "navbar-start" })]
        },
        proxy: true,
      },
      {
        key: "logo",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "navbar-item" },
              [
                _c("user-level-badge", {
                  attrs: { type: _vm.currentUser.type },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }